import { action, makeAutoObservable } from 'mobx';

export enum ExtendedDescriptionDataProvider {
  SHEET = 'sheet',
  EPISODE = 'episode'
}

class StoreUI {
  focusOnKey = '';
  activeEpisodeTab: 'episodes' | 'coming-soon' = 'episodes';
  toggles: {
    focusEpisodes: boolean;
    extendedEpisodeDescriptionDialog: {
      toggle: boolean;
      dataProvider: ExtendedDescriptionDataProvider;
    };
    invokeStartOver: boolean;
    providersVersionsDialog: boolean;
    recordingDialog: boolean;
  } = {
    focusEpisodes: false,
    extendedEpisodeDescriptionDialog: {
      toggle: false,
      dataProvider: ExtendedDescriptionDataProvider.SHEET
    },
    providersVersionsDialog: false,
    invokeStartOver: false,
    recordingDialog: false
  };

  constructor() {
    makeAutoObservable(this, {
      setFocusOnKey: action,
      toggleFocus: action,
      toggleExtendedEpisodeDescriptionDialog: action,
      toggleProvidersVersionsDialog: action,
      toggleRecordingDialog: action,
      reset: action
    });
  }

  setFocusOnKey(key: string) {
    this.focusOnKey = key;
  }

  setActiveEpisodeTab(tab: 'episodes' | 'coming-soon') {
    this.activeEpisodeTab = tab;
  }

  toggleInvokeStartOver(toggle: boolean) {
    this.toggles.invokeStartOver = toggle;
  }

  toggleProvidersVersionsDialog(toggle: boolean) {
    this.toggles.providersVersionsDialog = toggle;
  }

  toggleRecordingDialog(toggle: boolean) {
    this.toggles.recordingDialog = toggle;
  }

  toggleExtendedEpisodeDescriptionDialog(
    toggle: boolean,
    dataProvider: ExtendedDescriptionDataProvider
  ) {
    this.toggles.extendedEpisodeDescriptionDialog = {
      toggle,
      dataProvider
    };
  }

  toggleFocus(toggle: boolean) {
    this.toggles.focusEpisodes = toggle;
  }

  reset() {
    this.setActiveEpisodeTab('episodes');
    this.toggleExtendedEpisodeDescriptionDialog(false, ExtendedDescriptionDataProvider.SHEET);
    this.toggleFocus(false);
    this.toggleProvidersVersionsDialog(false);
    this.toggleRecordingDialog(false);
  }
}

export const uiStore = new StoreUI();
